import { Modal } from 'antd';
import { Icon as CroplerIcon, Button } from '@cropler/ui-kit';

import styles from './styles.module.scss';

import { BreakpointMobile, BreakpointMobileUp } from '../../constants/ui';
import { ImageBoxModal } from '../ImageBox/index.jsx';
import { ImageZoomMobile } from '../ImageZoomMobile/index.jsx';
import { useViewport } from '../../hooks';

const ImageZoomModals = ({
  fullImage,
  modalOpen,
  noImage = false,
  onCloseModal,
  isMask = false,
  processedMaskUrl = null,
  onPrevDate,
  onNextDate,
  hasPrevDate = false,
  hasNextDate = false,
}) => {
  const { widthViewport } = useViewport();
  const showMask = isMask && !!processedMaskUrl;

  const navButtons = (
    <>
      {onPrevDate && (
        <Button
          type="primary"
          icon={<CroplerIcon name="left" />}
          className={`${styles.imageZoomNav} ${styles.imageZoomNavPrev}`}
          disabled={!hasPrevDate}
          onClick={onPrevDate}
        />
      )}
      {onNextDate && (
        <Button
          type="primary"
          icon={<CroplerIcon name="left" />}
          className={`${styles.imageZoomNav} ${styles.imageZoomNavNext}`}
          disabled={!hasNextDate}
          onClick={onNextDate}
        />
      )}
    </>
  );

  return (
    <>
      {widthViewport > BreakpointMobile && !noImage && (
        <Modal centered footer={null} onCancel={onCloseModal} open={modalOpen} width={1100} className="modalImage">
          <ImageBoxModal imageUrl={fullImage} showMask={showMask} maskUrl={processedMaskUrl} />
          {navButtons}
        </Modal>
      )}

      {widthViewport < BreakpointMobileUp && modalOpen && (
        <ImageZoomMobile url={fullImage} showMask={showMask} maskUrl={processedMaskUrl} onCloseModal={onCloseModal}/>
      )}
    </>
  );
}

export default ImageZoomModals;